import { getConfigValue } from 'scripts/configs.ts';

/**
 * @deprecated Use getSite() instead.
 */
export async function isIms() {
	return (await getConfigValue('product-line'))?.toLowerCase() === 'ims';
}

export function getSite(): 'ims' | 'mis' {
	const origin = window.location.origin;
	if (
		origin.includes('ims.evidentscientific.com') ||
		origin.includes('eds-evident-website-ims') ||
		origin.includes('ims-evident-scientific')
	) {
		return 'ims';
	}
	return 'mis';
}
